const apiBaseUrl = (process.env.REACT_APP_API_URL || '').trim() || (
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8787'
    : 'https://api.tailli.latentsearch.io'
);

const config = {
  apiBaseUrl,
  endpoints: {
    customerList: '/api/GetCustomerList',
    apiKeyUnitsForMonth: '/api/ApiKeyUnitsForMonth',
    apiKeyUnitsThisMonth: '/api/ApiKeyUnitsThisMonth',
    apiKeyUnitsUsedLastMonth: '/api/ApiKeyUnitsUsedLastMonth',
    apiKeyUnitsUsedOnDate: '/api/ApiKeyUnitsUsedOnDate',
    // Add other endpoints here
  },
};

export default config;
